<template>
    <div class="change-btn">
        <div class="details-change-step">
            <span v-show="!isRecap" class="delais-popup-trigger" v-if="imageRecapDelais"
                  @click="fillAndOpenDefaultModal(imageRecapDelais)">Délais</span>
            <span v-show="!isRecap" class="garanties-popup-trigger" v-if="imageRecapGaranties"
                  @click="fillAndOpenDefaultModal(imageRecapGaranties)">Garanties</span>
        </div>
        <div class="buttons-change-step">
            <router-link v-if="showPrevBtn()" class="left retour" @click.native="prevBtnRecapPress"
                         tag="button" :to="{name:'constructor', params : {
                        type : $store.state.productType,
                        step : prevStep().toString()
                      }}">Retour
            </router-link>
            <router-link v-if="showNextBtn() && !preventNextButton" class="right next-step" @click.native="nextBtnPress"
                         tag="button" :to="{name:'constructor', params : {
                        type : $store.state.productType,
                        step : nextStep().toString()
                      }}">
                Étape suivante
            </router-link>
            <button v-else-if="!isRecap" class="right next-step disabled test"
                    data-tooltip="Merci de répondre à toute les questions de la page pour passer à l'etape suivante."
                    data-tooltip-position="top">
                Étape suivante
            </button>
        </div>
    </div>
</template>

<script>
    import stepDependenciesAreMet from "../lib/stepDependenciesAreMet";
    //let htmlToImage = require("html-to-image");
    //let htmlToJson = require("html-to-json");

    export default {
        name: "ChangeStep",
        mixins: [history],

        props: {
            step: Number,
            maxNumberOfSteps: Number
        },
        data() {
            return {
                backTo: this.step - 1,
                userlikeIClasses: "",
            }
        },

        mounted() {




            const userlikeI = document.querySelector("#userlike-button-symbol > i")
            if (userlikeI)
                this.userlikeIClasses = userlikeI.classList.value;
        },


        watch: {
            $route(to, from) {
                if (from.path === to.path) {
                    this.backTo--;
                    this.$router.push({
                        name: "constructor", params: {
                            type: this.$store.productType,
                            step: this.backTo,
                        }
                    })
                } else {
                    this.backTo = this.step
                }
            }
        },
        computed: {
            apiUrl() {
                return this.$store.state.apiUrl
            },
            answers() {
                return this.$store.state.answers || [];
            },
            steps() {
                return this.$store.state.steps || [];
            },
            validSteps() {
                return this.$store.state.validSteps || [];
            },
            isLastBtn() {
                const step = parseInt(this.step);

                return step + 1 === this.maxNumberOfSteps
            },
            isRecap() {
                return parseInt(this.$route.params.step) === Object.keys(this.$store.state.steps).length
            },
            isPrevLastScreen() {
                const step = parseInt(this.step);

                return step === this.maxNumberOfSteps
            },
            preventNextButton() {
                return this.$store.state.preventNextButton
            },
            isBackCapLocked() {
                return this.$store.state.lockBackCap
            },

            imageRecapDelais() {
                let famille = this.$store.state.families.find((e) => {
                    return e.Prefix === this.$store.state.productType
                });
                if (famille)
                    return famille.image_recap_delais;

                return false;
            },
            imageRecapGaranties() {
                let famille = this.$store.state.families.find((e) => {
                    return e.Prefix === this.$store.state.productType
                });
                if (famille)
                    return famille.image_recap_garanties;

                return false;
            },
        },

        methods: {

            fillAndOpenDefaultModal(imageUrl) {
                imageUrl = `${this.apiUrl}/${imageUrl}`
                let modal = $('#basicModal');
                modal.find('h5').text("");
                modal.find('img').attr('src', imageUrl);
                modal.find('.extra-popup').html("");
                modal.modal('show');
            },
            isNextStepHidden() {

                return !stepDependenciesAreMet(this.steps[parseInt(this.step) + 1], this.answers);
            },

            isPrevStepHidden(step) {
                let prevStep;
                if (step === undefined)
                    prevStep = parseInt(this.step) - 1;
                else
                    prevStep = parseInt(step) - 1;


                if (prevStep <= 0) {
                    return false;
                }

                return !stepDependenciesAreMet(this.steps[prevStep], this.answers);
            },

            nextStep() {
                return parseInt(this.step) + (this.isNextStepHidden() ? 2 : 1);
            },

            prevStep() {

                let prevStep = 1;
                for (let i = this.step; i >= 0; i--) {
                    if (!this.isPrevStepHidden(i)) {
                        prevStep = i - 1;
                        break;
                    }
                }
                return prevStep;
            },

            showNextBtn() {
                const step = parseInt(this.step);

                return (step + 1 <= this.maxNumberOfSteps && this.validSteps.indexOf(String(step)) !== -1) || (this.steps[this.step] !== undefined && this.steps[this.step].noRequire !== undefined && this.steps[this.step].noRequire);
            },

            showPrevBtn() {

                return parseInt(this.step) - 1 !== 0 && !this.isBackCapLocked
            },
            nextBtnPress() {
                /* if (this.isLastBtn) {
                     //this.$store.dispatch('toggleLoader');
                     let previewNode = "";
                     let flipper = document.querySelector('.flipper');
                     let flipperClone = flipper.cloneNode(true);

                     flipperClone.id = "flipperClone";
                     flipperClone.style.width = flipper.offsetWidth*2+'px';
                     flipperClone.style.height = flipper.offsetHeight+'px';
                     flipperClone.style.display = 'flex';
                     flipperClone.style.flexDirection = 'space-between';

                     flipperClone.style.position = 'fixed';
                     flipperClone.style.top = '-'+flipperClone.height+'px';
                     _.each(flipperClone.children, (el) => {
                         el.style.position = 'inherit';
                         el.style.transform = 'rotateY(0deg)';
                         el.style.backfaceVisibility = 'inherit'
                     });
                     let parsedElem = {};

                     function recursiveParseNode(node) {

                     }
                 }*/


                if (this.isLastBtn) {
                    this.$store.dispatch('calculatePrice')
                }
                window.scrollTo(0,0);
            },
            prevBtnRecapPress() {
                window.scrollTo(0,0);
                if (this.isPrevLastScreen) {
                    this.$store.dispatch('saveProductPreviewNode', null)
                    this.$store.dispatch('calculatePrice', null)
                }
            },
        }
    }
</script>


<style scoped>
    .delais-popup-trigger,
    .garanties-popup-trigger {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        min-width: 100px;
        min-height: 48px;
        background: rgb(0, 0, 0);
        cursor: pointer;
        color: #ffffff;
        font-weight: normal;
        font-size: 16px;
        margin-bottom: 2px;
        margin-right: 2px;
    }


    [data-tooltip] {
        position: relative;
    }

    [data-tooltip-position="top"]:after {
        z-index: 50;
        content: '';
        display: none;
        position: absolute;
        width: 0;
        height: 0;
        border: solid transparent;
    }

    [data-tooltip-position="top"]::after {
        bottom: 125%;
        border-width: 6px 6px 0;
        border-top-color: #000;
        left: 50%;
        margin-left: -6px;
        margin-bottom: -6px;
    }

    [data-tooltip]:hover::before,
    [data-tooltip]:hover::after {
        display: block;
    }

    /* Tooltip styling */
    [data-tooltip]::before {
        content: attr(data-tooltip);
        display: none;
        position: absolute;
        background: #000;
        color: #fff;
        padding: 4px 8px;
        font-size: 14px;
        line-height: 1.4;
        min-width: 260px;
        text-align: center;
        border-radius: 4px;
    }

    [data-tooltip-position="top"]::before {
        left: 50%;
        -ms-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    [data-tooltip-position="top"]::before {
        bottom: 100%;
        margin-bottom: 10px;
    }

    .call-to-action-arrow {
        width: 0;
        height: 0;
        border: 6px solid;
        border-bottom-color: transparent;
        border-left-color: transparent;
        position: relative;
        display: inline-block;
        color: rgb(233, 167, 6);
        box-sizing: border-box;
        transform: rotate(75deg);
        margin-left: 85px;
        margin-top: 40px;
    }

    .call-to-action-arrow::before {
        content: "";
        right: 0;
        top: -3px;
        position: absolute;
        height: 4px;
        box-shadow: inset 0 0 0 32px;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        width: 85px;
        -webkit-transform-origin: right top;
        transform-origin: right top;
    }

    .customer-warning {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .customer-warning span {
        font-size: 20px;
        margin-right: 15px;
        font-weight: 700;
    }

    #userlike-button-symbol-warning {
        font-family: "userlike_default" !important;
        background-color: rgb(233, 167, 6);
        color: #ffffff;
    }

    #userlike-button-symbol-warning {
        width: 64px;
        min-width: 64px;
        max-width: 64px;
        height: 64px;
        min-height: 64px;
        max-height: 64px;
        padding: 0;
        border-radius: 50%;
        overflow: visible;
    }

    #userlike-button-symbol-warning i {
        display: inline-block;
        float: none;
        height: 44px;
        font-family: userlike_default;
        font-size: 43px;
        font-style: normal;
        font-weight: 400;
        user-select: none;
        width: 43px;
    }

    .disabled {
        background: #c4c4c5 !important;
    }


    .change-btn {
        width: 100%;
        display: flex;
        position: fixed;
        float: none;
        clear: none;
        bottom: 0;
        left: 0;
        padding: 25px 5px;
        justify-content: flex-start;
        background: #ffffff;
    }

    .details-change-step {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .buttons-change-step{
        display: flex;
        align-items: flex-start;
        flex-direction: column-reverse;
    }


    .change-btn button,
    .change-btn button:focus {
        border: none;
        box-shadow: none;
        border-radius:0!important;
        cursor: pointer;
        padding: 14px 15px;
        color: #fff;
        z-index: 10;
        position: relative;
        outline: none;
        min-width: 175px;
        font-weight: normal;
        font-size: 16px;

        margin-bottom: 2px;
    }
    .change-btn button.next-step,
    .change-btn button.next-step:focus {
        color: rgb(0, 0, 0);
    }



    .change-btn .left {
        background: #747878;
    }
    .change-btn .retour.left {
        background: rgb(0, 0, 0);
    }


    .left {

    }

    .right {
        font-weight: 400;
    }

    .right-text {
        /* float: right; */
        /* margin: 1%; */
    }

    .right-text span {

        font-weight: bold;
        color: red;
        font-size: 18px;
    }




    @media screen and (max-width:816px){

        .details-change-step{
            //display: none;
        }
    }

    @media screen and (min-width: 1024px) {
        .change-btn{
            display: none;
        }
    }

</style>
